import Button from "@/components/atoms/Button";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/atoms/Form";
import PasswordInput from "@/components/atoms/PasswordInput/PasswordInput";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";



const getFormSchema = () =>
  z
    .object({
      password: z.string().min(1, "Password is required"),
      passwordConfirmation: z.string().min(1, "Password confirmation is required")
    })
    .refine(
      (data) =>
        (data.password && data.password === data.passwordConfirmation),
      {
        path: ["passwordConfirmation"], // Target this field for the error message
        message: "Passwords must match.",
      }
    );

type formData = z.infer<ReturnType<typeof getFormSchema>>;

type Props = {
  onSubmit: (data: formData) => void;
  isSubmitting?: boolean;
};

export const useConfirmationForm = () =>
  useForm<formData>({
    resolver: zodResolver(getFormSchema()),
    defaultValues: {
      password: "",
      passwordConfirmation: "",
    },
  });


const ResetPasswordForm = ({
  onSubmit,
  isSubmitting,
} : Props) => {
  const form = useConfirmationForm();

  const handleSubmit = (data: formData) => {
    onSubmit(data);
  };

  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(handleSubmit)}
          className="space-y-8 w-full"
        >

          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem className="w-full">
                <FormLabel>New Password*</FormLabel>
                <FormControl>
                  <PasswordInput field={{ ...field, value: field.value || "" }} placeholder="New Password" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="passwordConfirmation"
            render={({ field }) => (
              <FormItem className="w-full">
                <FormLabel>Confirm New Password*</FormLabel>
                <FormControl>
                  <PasswordInput field={{ ...field, value: field.value || "" }} placeholder="Re-enter new Password" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <Button type="submit" disabled={isSubmitting} className="flex w-full p-4 rounded-xl">
            {isSubmitting ? "Submitting..." : "Reset Password"}
          </Button>
        </form>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
